exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-item[data-v-58833478] {\n  padding: 15px;\n  background: #f8f8f8;\n  margin-bottom: 15px;\n}\n.list-item-title[data-v-58833478] {\n    font-size: 16px;\n}\n.list-item-obj[data-v-58833478] {\n    font-size: 14px;\n}\n.list-item-period[data-v-58833478] {\n    font-size: 12px;\n}\n.list-item-status[data-v-58833478] {\n    font-size: 16px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-58833478","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/member/activity/index.vue
// module id = 1495
// module chunks = 0